import {Pipe, PipeTransform} from '@angular/core'

/**
 * @public
 */
@Pipe({
  name: 'decodeHtmlString',
  standalone: true
})
export class DecodeHtmlStringPipe implements PipeTransform {

  private readonly _lineBreakPattern = /<br\s*\/?>/gi
  private readonly _lineBreakSubstitution = '\n'
  private readonly _domParser: DOMParser = new DOMParser()

  /**
   * Parses HTML Entities and makes linebreaks consistent
   *
   * @param value The initial raw value passed to the pipe
   */
  transform(value = ''): string {
    if (typeof value !== 'string') {
      return value
    }

    value = value.replace(this._lineBreakPattern, this._lineBreakSubstitution)
    value = this._domParser.parseFromString(value, 'text/html')
      ?.documentElement
      ?.textContent
      ?.trim() ?? ''
    return value.replace(this._lineBreakPattern, this._lineBreakSubstitution)
  }

}
